export const KPIs = {
  CPC: 'Cost per click',
  maxBid: 'Max Bid',
  pcCPE: 'Post click CPE',
  pcROAS: 'Post click ROAS',
  pcSkuROAS: 'Post click SKU ROAS',
  totalCPE: 'Total CPE',
  totalROAS: 'Total ROAS',
  CTR: 'CTR',
  CPM: 'CPM',
};

export const KPIsInOrder = [
  'maxBid',
  'CPM',
  'CTR',
  'CPC',
  'totalCPE',
  'pcCPE',
  'totalROAS',
  'pcROAS',
  'pcSkuROAS',
];

export const aggregationLevelDescriptions = {
  0: 'Same ad type, objective, brand and country.',
  1: 'Same ad type, objective and brand in the similar countries.',
  2: 'Same ad type, objective and country with the peer brands.',
  3: 'Same ad type, objective and peer brands in the similar countries.',
  4: 'Same ad type, objective, country and all brands in the same pool.',
  5: 'Same ad type, objective, and all brands in the same pool in similar countries.',
  6: 'Same ad type, objective and brand in all countries.',
  7: 'Same ad type, objective and peer brands in all countries.',
  8: 'Same ad type, objective and all brands in the same pool in all countries.',
  9: 'Same ad type, objective, country and all brands in all pools.',
  10: 'Same ad type, objective and all brands in all pools in the similar countries.',
  11: 'Same ad type, objective and all brands in all pools in all countries.',
};

export const AGGREGATION_LEVEL_COLOR_MAP = [
  '#006400',
  '#1A7312',
  '#348224',
  '#4E8F36',
  '#689D47',
  '#82A959',
  '#9AB56B',
  '#B1C07D',
  '#C6CB8F',
  '#D5D1A1',
  '#DED5B3',
  '#E7DAC4',
];

export const BUSINESS_MODELS = [
  { label: 'Wholesale', value: 'Wholesale' },
  { label: 'Partner Program', value: 'Partner Program' },
];
